<div
	class="tw:absolute tw:left-0 tw:top-0 tw:bottom-0 tw:w-(--side-menu-width) tw:hidden tw:lg:flex tw:flex-col tw:py-6 tw:bg-surface-primary">
	<div class="tw:text-center tw:pb-6 tw:relative">
		@if (isBeta) {
		<img width="144" height="48" src="/logos/zeraki-finance-beta.svg" class="logo" alt="" />
		} @else if (isTest) {
		<img width="144" height="48" src="/logos/zeraki-finance-testing.svg" class="logo" alt="" />
		} @else {
		<img width="144" height="48" src="/logos/zeraki-finance.svg" class="logo" alt="" />
		}
	</div>

	<div class="tw:flex tw:flex-col tw:gap-4 tw:grow tw:overflow-y-auto show-scrollbar">
		@if (userRole.isStoresManager()) {
		<div class="tw:p-2 tw:text-secondary tw:font-bold">STORES AND INVENTORY</div>

		<z-side-menu-item icon="build" route="/stores-inventory/setup">
			{{ "sideMenu.setup" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="inventory_2" route="/stores-inventory/inventory-register">
			{{ "sideMenu.inventoryRegister" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="box" route="/stores-inventory/internal-use-items">
			{{ "sideMenu.itemIssuance" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="article" route="/stores-inventory/inventory-reports">
			{{ "sideMenu.inventoryReports" | translate }}
		</z-side-menu-item>
		@if (userPermissions.canAccessExpenses()) {
		<z-side-menu-item icon="local_shipping" route="/expense/suppliers">
			{{ "expenses.suppliers.title" | translate }}
		</z-side-menu-item>
		}
		@if (userPermissions.canAccessPayroll() && userPermissions.canAccessExpenses() && (school.isKenyanSchool || school.isUgandanSchool)) {
		<z-side-menu-item icon="groups" [route]="school.isPrivateSchool ? '/staff' : '/payroll/staff-management'">
			{{ "sideMenu.staffManagement" | translate }}
		</z-side-menu-item>
		}
		} @else {
		<z-side-menu-item icon="dashboard" route="/dashboard">
			{{ "sideMenu.dashboard" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="groups" route="/students">
			{{ "sideMenu.students" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="checkbook" route="/invoicing">
			{{ "sideMenu.invoicing" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="money_bag" route="/collections">
			{{ "sideMenu.collections" | translate }}
		</z-side-menu-item>

		@if (userPermissions.canAccessExpenses()) {
		<z-side-menu-item icon="payment_arrow_down" route="/expense">
			{{ "sideMenu.expenses" | translate }}
		</z-side-menu-item>
		}


		<z-side-menu-item icon="home_repair_service" route="/other-income">
			{{ "sideMenu.otherIncome" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="rule_settings" route="/integrations">
			{{ "setting.intergrations.intergrations" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="account_balance" route="/accounting">
			{{ "sideMenu.accounting" | translate }}
		</z-side-menu-item>

		@if (userPermissions.canAccessPayroll() && userPermissions.canAccessExpenses() && (school.isKenyanSchool ||
		school.isUgandanSchool)) {
		<z-side-menu-item icon="folder_shared" [hasSubMenu]="true" [subRoutes]="['/payroll']">
			{{ "sideMenu.staffAndPayroll" | translate }}
			<z-sub-menu>
				<z-sub-menu-item route="/payroll/general-setup">{{ "sideMenu.payrollSetup" | translate
					}}</z-sub-menu-item>
				@if (school.isPrivateSchool) {
				<z-sub-menu-item route="/staff">{{ "sideMenu.staffManagement" | translate }}</z-sub-menu-item>
				} @else {
				<z-sub-menu-item route="/payroll/staff-management">
					{{ "sideMenu.staffManagement" | translate }}
				</z-sub-menu-item>
				}
				<z-sub-menu-item route="/payroll/payroll-management">
					{{ "sideMenu.payrollManagement" | translate }}
				</z-sub-menu-item>
			</z-sub-menu>
		</z-side-menu-item>
		}

		<z-side-menu-item icon="lab_profile" [hasSubMenu]="true"
			[subRoutes]="['/student-reports', '/summary-reports', '/financial-reports', '/ipsas-reports', '/aging-reports']">
			{{ "sideMenu.reports" | translate }}
			<z-sub-menu>
				<z-sub-menu-item route="/student-reports">{{ "sideMenu.studentReports" | translate }}</z-sub-menu-item>
				<z-sub-menu-item route="/summary-reports">{{ "sideMenu.summaryReports" | translate }}</z-sub-menu-item>
				@if (school.isPrivateSchool) {
				<z-sub-menu-item route="/private-financial-reports">
					{{ "sideMenu.financialReports" | translate }}
				</z-sub-menu-item>
				} @else if (userPermissions.canAccessFinancialReports() && userPermissions.canAccessExpenses()) {
				<z-sub-menu-item route="/financial-reports">{{ "sideMenu.financialReports" | translate
					}}</z-sub-menu-item>
				<z-sub-menu-item route="/ipsas-reports">{{ "sideMenu.ipsasReports" | translate }}</z-sub-menu-item>
				}
				<z-sub-menu-item route="/aging-reports">{{ "sideMenu.agingReports" | translate }}</z-sub-menu-item>
			</z-sub-menu>
		</z-side-menu-item>

		<z-side-menu-item icon="store" [hasSubMenu]="true" [subRoutes]="['/stores-inventory']">
			{{ "sideMenu.storesAndInventory" | translate }}
			<z-sub-menu>
				<z-sub-menu-item route="/stores-inventory/setup">{{ "sideMenu.setup" | translate }}</z-sub-menu-item>
				<z-sub-menu-item route="/stores-inventory/inventory-register">
					{{ "sideMenu.inventoryRegister" | translate }}
				</z-sub-menu-item>
				<z-sub-menu-item route="/stores-inventory/internal-use-items">
					{{ "sideMenu.itemIssuance" | translate }}
				</z-sub-menu-item>
				<z-sub-menu-item route="/stores-inventory/inventory-reports">
					{{ "sideMenu.inventoryReports" | translate }}
				</z-sub-menu-item>
			</z-sub-menu>
		</z-side-menu-item>

		<z-side-menu-item icon="directions_bus" route="/transport">Transport</z-side-menu-item>

		@if (userPermissions.canAccessPocketMoney()) {
		<z-side-menu-item icon="payments" route="/pocket-money">
			{{ "sideMenu.pocketMoney" | translate }}
		</z-side-menu-item>
		}

		<z-side-menu-item icon="forum" route="/messaging">
			{{ "sideMenu.messaging" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="assignment" route="/asset-management">
			{{ "sideMenu.assetManagement" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="receipt_long" route="/billing">
			{{ "sideMenu.billing" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="build" route="/configurations">
			{{ "sideMenu.configurations" | translate }}
		</z-side-menu-item>

		<z-side-menu-item icon="delete" route="/deletion-logs">
			{{ "deletionLogs.deletionLogs" | translate }}
		</z-side-menu-item>
		}
	</div>
</div>